<template>
	<div>
		<div class="l-container">
			<div class="visual-area">
				<div class="circle-area">
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
					<div class="circle"></div>
				</div>
				<strong class="tit">Our Business</strong>
				We have a variety of business models to create new services.<br />Our
				commitment to our customers will continue.
			</div>
			<ul class="scope-of-works">
				<li class="consult">
					<strong>Consulting</strong>
					고객의 비즈니스 목적에 맞는 <br />
					분석과 전략으로 최적의 서비스를 <br />
					제공합니다.
				</li>
				<li class="design">
					<strong>UI/UX Design</strong>
					다양한 사용자에게 확장될 수 있는<br />
					쉽고 안정적인 UI/UX 디자인<br />
					환경을 만들어 갑니다.
				</li>
				<li class="developement">
					<strong>Development</strong>
					다양한 플랫폼과 새로운 기술에 대한<br />
					지속적인 경험으로 빠르게 변화하는 <br />
					환경에 유연하게 대응합니다.
				</li>
				<li class="marketing">
					<strong>Marketing</strong>
					고객에게 최적화된 마케팅 전략은<br />
					새로운 브랜드로의 소통이<br />
					가능 할 수 있도록 지원합니다.
				</li>
			</ul>
			<div class="partner-list">
				<strong class="tit">Partners</strong>
				<transition-group tag="ul" name="fadeUp">
					<li
						v-for="(partner, index) in partnerList"
						:key="partner.id"
						:data-index="index"
					>
						<img :src="partner.imgsrc" :alt="partner.imgalt" />
					</li>
				</transition-group>
				<!-- <button class="btn-more-partner"><span class="a11y-hidden">파트너 더보기</span></button> -->
			</div>
		</div>
	</div>
</template>

<script>
import { store } from "../data/store.js";
export default {
	metaInfo: {
		title: "About Us",
		meta: [
			{
				vmid: "description",
				name: "description",
				content:
					"제오젠은 웹컨설팅, UI/UX디자인, 개발, 마케팅하는 크리에이티브 그룹입니다.",
			},
		],
	},
	data() {
		return {
			store,
			partnerList: {},
		};
	},
	mounted: function () {
		this.partnerList = store.partners;
	},
	methods: {},
	watch: {},
	created() {
		//console.log("xgAboutus");
	},
};
</script>


// WEBPACK FOOTER //
// src/components/XgAboutus.vue